import { observer } from "mobx-react";
import { h } from "preact";
import { useEffect, useRef } from "preact/hooks";
import ProductLabels from "../../components/ProductLabels";
function LabelSection(props) {
    // Set vertical align to the top if any label is present (like in: themes/base/partials/menu_group_section_item.liquid:68)
    // NOTICE: This is a hack... Remove it when the `.m-item__col` will be in the Preact
    const elRef = useRef(null);
    useEffect(() => {
        var _a;
        const header = (_a = elRef.current) === null || _a === void 0 ? void 0 : _a.closest(".m-item__col-header");
        if (!header) {
            return;
        }
        const { labels } = props.labelsCreator;
        // Add vertical align to the top if there are any labels
        if (labels.length > 0) {
            header.classList.add("u-va-top");
            // Remove vertical align only if no other labels are present
        }
        else if (header.querySelector(".m-item__labels .label") === null) {
            header.classList.remove("u-va-top");
        }
    }, [props.labelsCreator.labels]);
    return (h("span", { ref: elRef },
        h(ProductLabels, { labelsCreator: props.labelsCreator, schedule: props.schedule })));
}
export default observer(LabelSection);
